module.exports = __webpack_public_path__ + "img/fotof.f6607f92.png";